/**
 * Returns true/false if reduced motion is active/inactive
 */
export function userPrefersReducedMotion() {
  return matchMedia('(prefers-reduced-motion)').matches;
}
